/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Alerts_HelperInputs */

const es_billing_alerts_helper = /** @type {(inputs: Billing_Alerts_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las alertas se envían al email configurado del administrador.`)
};

const en_billing_alerts_helper = /** @type {(inputs: Billing_Alerts_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alerts are sent to the configured administrator email.`)
};

/**
* | output |
* | --- |
* | "Alerts are sent to the configured administrator email." |
*
* @param {Billing_Alerts_HelperInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_alerts_helper = /** @type {((inputs?: Billing_Alerts_HelperInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Alerts_HelperInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_alerts_helper(inputs)
	return en_billing_alerts_helper(inputs)
});
export { billing_alerts_helper as "billing.alerts.helper" }